import React from "react";
import { Link } from "react-router-dom";

interface FooterProps {
  variant?: "default" | "dark";
}

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-10">
      <div className="max-w-4xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <Link
          to="/"
          className="text-xs tracking-widest uppercase opacity-40 hover:opacity-80 transition-opacity"
          style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
        >
          TCGL
        </Link>

        <div className="flex gap-6">
          <Link
            to="/privacy-policy"
            className="text-xs text-white/30 hover:text-white/60 transition-colors"
          >
            Privacy
          </Link>
          <Link
            to="/terms-conditions"
            className="text-xs text-white/30 hover:text-white/60 transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/cookie-policy"
            className="text-xs text-white/30 hover:text-white/60 transition-colors"
          >
            Cookies
          </Link>
        </div>

        <p className="text-xs text-white/20">
          &copy; {new Date().getFullYear()} The Content Group Limited
        </p>
      </div>
    </footer>
  );
};

export default Footer;
